<div class="consolidated">
  <!-- Herói do grupo (protótipo 01): a conclusão do grupo primeiro. -->
  <section class="pit-card consolidated__hero" aria-label="Visão consolidada dos sócios">
    <!-- Pior nível entre os sócios e de onde vem; os pontos do grupo ficam só no card de pontos, embaixo. -->
    @if (conclusion().tagLabel) {
      <span [class]="'pit-tag ' + conclusion().tagCss">{{ conclusion().tagLabel }}</span>
    }
    <h2 class="consolidated__conclusion">{{ conclusion().text }}</h2>
    <p class="consolidated__line">
      <b>Consolidado</b> · {{ partnerCount() }} {{ partnerCount() === 1 ? 'sócio' : 'sócios' }} · PL
      somado {{ money(consolidated().netWorthTotal) }} · dívidas
      {{ consolidated().debtsTotal ? money(consolidated().debtsTotal) : 'nenhuma' }}
    </p>
  </section>

  <section class="pit-row" aria-label="Indicadores do grupo">
    <div class="pit-kpi">
      <p class="pit-kpi__label">Patrimônio líquido somado</p>
      <p class="pit-kpi__value">{{ money(consolidated().netWorthTotal) }}</p>
      @if (netWorthNote()) {
        <p
          class="pit-kpi__note"
          [class.pit-positive]="tone(consolidated().netWorthYoY) === 'positive'"
          [class.pit-negative]="tone(consolidated().netWorthYoY) === 'negative'">
          {{ netWorthNote() }}
        </p>
      }
      <!-- PL somado só nos anos comparáveis, como o total do comparativo. -->
      <app-pit-sparkline
        [series]="netWorthSeries()"
        [label]="'Patrimônio líquido somado por ano'" />
    </div>
    <div class="pit-kpi">
      <p class="pit-kpi__label">Dívidas somadas dos sócios</p>
      <p class="pit-kpi__value">{{ money(consolidated().debtsTotal) }}</p>
      @if (consolidated().debtsTotal && consolidated().debtsOverNetWorth !== null) {
        <!-- Mesma cor de nível e mesma barra do KPI do sócio (N17). -->
        <p
          class="pit-kpi__note"
          [class.pit-negative]="debtsLevel() === 'critico'"
          [class.pit-warning]="debtsLevel() === 'atencao'">
          {{ ratio(consolidated().debtsOverNetWorth) }} do PL somado
        </p>
        <app-pit-debt-bar
          [ratio]="consolidated().debtsOverNetWorth"
          [limits]="debtLimits()"
          [level]="debtsLevel()"
          [reference]="'do patrimônio somado'" />
      }
    </div>
    <div class="pit-kpi">
      <p class="pit-kpi__label">Capacidade livre de garantia</p>
      @if (policyDefined()) {
        <p class="pit-kpi__value">{{ money(consolidated().freeCollateralTotal) }}</p>
        @if (consolidated().restrictedCollateralTotal) {
          <p class="pit-kpi__note">
            {{ money(consolidated().restrictedCollateralTotal) }} com restrição
          </p>
        }
      } @else {
        <p class="pit-kpi__value">—</p>
        <a
          *appHasRole="'ADMIN'"
          class="pit-link consolidated__link"
          [routerLink]="parametrizationRoute"
          >Definir política de garantias</a
        >
        <p class="pit-kpi__note">sem política definida</p>
      }
    </div>
    @if (policyDefined()) {
      <div class="pit-kpi">
        <p class="pit-kpi__label">Livre e sem restrição</p>
        <p class="pit-kpi__value">{{ money(consolidated().unrestrictedCollateralTotal) }}</p>
        <p class="pit-kpi__note">sem restrição jurídica</p>
      </div>
    }
    <!--
      Sem o campo "Garantia exigida" (revisão com o Bruno, 29/10/2026): a exigência depende da operação que for
      estruturada, não do IR dos sócios.
    -->
  </section>

  <app-pit-finding-list
    [findings]="consolidated().findings"
    [allowExpand]="false"
    [heading]="'Pontos de atenção do grupo'"
    [emptyText]="groupEmptyText()"
    [subheading]="
      'Pontos que dependem de mais de um sócio, como bens do casal e garantias já comprometidas.'
    " />

  <div class="consolidated__sections">
    <app-pit-section-tabs
      [tabs]="tabs()"
      [active]="section()"
      (selectSection)="sections.select($event)" />

    @switch (section()) {
      @case ('comparison') {
        <app-pit-comparison-table
          [consolidated]="consolidated()"
          [policyDefined]="policyDefined()"
          (openPartner)="openPartner.emit($event)" />
      }
      @case ('coverage') {
        <app-pit-coverage-card [consolidated]="consolidated()" />
      }
      @case ('documents') {
        <app-pit-documents-section />
      }
    }
  </div>
</div>
